/* eslint-disable react/prop-types */
import React from 'react';
import Menu from '@ublend-npm/aulaui-next-web/Menu';
import MenuItem from '@ublend-npm/aulaui-next-web/MenuItem';
import Avatar from '@ublend-npm/aulaui-next-web/Avatar';
import ToolButton from './ToolButton';
import { menuListClassName } from './ToolSelector.styled';

const id = Math.random().toString(36).substr(2, 9);

const ToolSelector = ({ compact, currentTool, tools, onToolChange }) => (
  <div id={`menu-tool-${id}`}>
    <Menu
      classes={{ menu: menuListClassName }}
      menuListComponent="ul"
      menuListAttributes={{ role: 'listbox', 'aria-label': 'Select a tool' }}
      ariaLabelledby={`menu-tool-${id}`}
      data-testid="current-assignment-tool"
      anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      transformOrigin={{ vertical: 'top', horizontal: 'left' }}
      renderTarget={({ handleTargetClick }) => (
        <ToolButton
          compact={compact}
          tool={currentTool}
          onClick={handleTargetClick}
        />
      )}
      onSelect={({ item }) => item()}
      renderChildren={({ getItemProps }) =>
        tools.map((tool) => (
          <MenuItem
            data-testid={`${tool.name}-assignment-tool`}
            size="large"
            key={tool.name}
            leftDecoration={<Avatar src={tool.logo} name={tool.logo} />}
            primaryText={tool.name}
            {...getItemProps({
              item: () => onToolChange(tool),
              onClick: (e) => e.stopPropagation(),
            })}
          />
        ))
      }
    />
  </div>
);

export default ToolSelector;
